const appendText = (doc, parent, text, fontSize) => {
    const paragraph = doc.createElement('p')
    paragraph.textContent = String(text || '')
    paragraph.style.cssText = `font-weight:bolder;font-size:${fontSize}px;width:100%;margin:0;text-align:left;`
    parent.appendChild(paragraph)
}

export const openPrintPreview = ({ qrCodeElement, sections }) => {
    // No `noopener`/`noreferrer`: this opens a blank, same-origin window
    // whose content is written entirely by this script below (never
    // navigated to an external/untrusted URL), so there's no tabnabbing
    // risk to guard against here. `noopener` always makes `window.open()`
    // return `null` per spec, which broke this feature entirely.
    const printWindow = window.open('', '')
    if (!printWindow) return

    const doc = printWindow.document
    const style = doc.createElement('style')
    style.media = 'print'
    style.textContent = '@page { size: auto; margin: 0mm; }'
    doc.head.appendChild(style)
    doc.body.style.margin = '0mm'

    const container = doc.createElement('div')
    container.style.cssText = 'width:100%;text-align:center;'
    if (qrCodeElement) {
        const image = doc.createElement('img')
        image.src = qrCodeElement.toDataURL()
        image.alt = 'QR Code'
        image.width = 200
        image.height = 30
        container.appendChild(image)
    }

    const content = doc.createElement('div')
    content.style.cssText = 'width:200px;height:70px;margin:auto;'
    sections.forEach(({ text, fontSize, width = '70%' }) => {
        const column = doc.createElement('div')
        column.style.cssText = `float:left;width:${width};`
        appendText(doc, column, text, fontSize)
        content.appendChild(column)
    })
    container.appendChild(content)
    doc.body.replaceChildren(container)
    setTimeout(() => printWindow.print(), 1000)
}
